var _circle, _ellipse, _path, _path2, _path3, _path4, _circle2, _circle3, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBinocularsEmptyState = function SvgBinocularsEmptyState(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 146,
    viewBox: "0 0 194 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 73,
    r: 73,
    fill: "#E8EAF6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.8364,
    cy: 92.5117,
    rx: 95.5,
    ry: 20.5,
    fill: "url(#paint0_radial_4053_45468)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86154 65.4597L24.4016 61.0957V81.3339L2.86154 76.9699C2.86154 76.9699 0.663561 76.7517 0.663574 71.2148C0.663588 65.6779 2.86154 65.4597 2.86154 65.4597Z",
    fill: "#536DFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3367 55.1616L75.986 42.9883V99.4422L16.3367 87.2688C16.3367 87.2688 10.25 86.6601 10.25 71.2152C10.25 55.7703 16.3367 55.1616 16.3367 55.1616Z",
    fill: "url(#paint1_linear_4053_45468)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9034 51.5938C33.9034 51.5938 26.3796 53.7932 26.3796 71.2165C26.3796 88.6398 33.9034 90.8392 33.9034 90.8392",
    stroke: "#EEEDFF",
    strokeWidth: 0.608667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6166 55.1616L134.266 42.9883V99.4422L74.6166 87.2688C74.6166 87.2688 68.5299 86.6601 68.5299 71.2152C68.5299 55.7703 74.6166 55.1616 74.6166 55.1616Z",
    fill: "url(#paint2_linear_4053_45468)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.91,
    cy: 71.2152,
    r: 28.2269,
    fill: "#657DFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.19,
    cy: 71.2152,
    r: 28.2269,
    fill: "#657DFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.161 61.2946L180.411 52.6211",
    stroke: "#7186FE",
    strokeWidth: 1.06517
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168.161 81.9886L180.411 90.6621",
    stroke: "#7186FE",
    strokeWidth: 1.06517
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.911 71.6426L185.052 71.6426",
    stroke: "#7186FE",
    strokeWidth: 1.06517
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4053_45468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.8364 92.5117) scale(95.5 20.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#657DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EAF6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4053_45468",
    x1: 12.989,
    y1: 103.627,
    x2: 48.8243,
    y2: 35.2278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#536DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4053_45468",
    x1: 71.2689,
    y1: 103.627,
    x2: 107.104,
    y2: 35.2278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#536DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5CEFF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBinocularsEmptyState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "binoculars-empty-state.3babd6ad9133c84d8eaa7231f1fd328e.svg";